import Vue from "vue";
import GutenbergAPI from "./GutenbergAPI";

Vue.use(GutenbergAPI);